import type { FaireProductEntity } from "../../entity_types/product";

export const p_buptewzwhs: FaireProductEntity = {
  token: "p_buptewzwhs",
  type: "product",
  name: "Astral Realms Crystal Oracle by Leah Shoman",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/9558f5bd507a0a9a3e7a444d317bee182dfb7a873453e4417e6268841bfff26b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c3ddb97e4e12f6446932ad3e946a455ff58d6fd8525230241a334c786628b73.jpeg",
    "https://cdn.faire.com/fastly/6639d342b87d49640889f3907357886bb3f948ca7c20cb183425d2cac87ab736.jpeg",
    "https://cdn.faire.com/fastly/db81617ee3eb91232fba51ce2348d2efac88305208c74bb336b49d4f7eacdbe9.jpeg",
  ],
  priceDollars: 17.29,
  description:
    "[Rockpool Publishing]\r\n\r\nAstral Realms Crystal Oracle is a portal into the esoteric world of crystal healing and celestial influence. Captivating and symbolic imagery transports the reader to high-frequency realms, cultivating a deeper connection to source and self. An immersive companion guidebook gives insight into and understanding about crystalline energies and universal principles, acting as an energetic link between the physical and spiritual realms. Above all the guidebook was written with the intention of encouraging the reader to transform their perspective and elevate their tangible experience. A channel of insight from above and within, Astral Realms Crystal Oracle is a timeless and dimensionless tool that will speak to your soul, answering your questions and expanding your consciousness.",
  tags: [],
  msrpDollars: 34.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:15.517Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
